module.exports = __webpack_public_path__ + "img/bear_h100.png";